import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from '../axios.jsx';
import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';

const URI_CIT = 'cierre/';
const URI3 = 'sendmailSAT/'


const ViewCierre = () => {
  const { codigo } = useParams();
  const navigate = useNavigate();

  const [citas, setCitas] = useState([]);
  const [reuniones, setReuniones] = useState([]);
  const [loading, setLoading] = useState(false);

  const [viewItem, setViewItem] = useState(null);
  const [showViewCitas, setShowViewCitas] = useState(false);

  const [showEditCitas, setShowEditCitas] = useState(false);

  

  const [showModalCita, setShowModalCita] = useState(false);


  const [fechaCita, setFechaCita] = useState('');

  const [tema, setTema] = useState('');


  const [gestor, setGestor] = useState('');
  const [usernivel, setUsernivel] = useState('');

  const resetCitaFields = () => {
    setFechaCita('');
    setTema('');
  };


  useEffect(() => {
    const user = sessionStorage.getItem('username');
    const nivel = sessionStorage.getItem('usernivel');
    if (user) setGestor(user);
    if (nivel) setUsernivel(nivel);

    const hoy = new Date().toISOString().split('T')[0];
    setFechaCita(hoy);

    fetchData();
    }, [codigo]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [resC] = await Promise.all([
        axios.get(`${URI_CIT}${codigo}`),
           ]);
      const norm = data => Array.isArray(data) ? data : data ? [data] : [];
      setCitas(norm(resC.data));
         } catch (err) {
      console.error(err);
      Swal.fire({ icon: 'error', title: 'Error al cargar datos' });
      setCitas([]);
     } finally {
      setLoading(false);
    }
  };

  const handleDeleteCita = async (id) => {
    if (usernivel === '1') {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: 'Esta acción eliminará la cita permanentemente.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  });
  

  if (result.isConfirmed) {
    try {
      await axios.delete(`${URI_CIT}${id}`);
      await axios.put(`sat/codigo/${codigo}`, 
            {Cierra_SAT:"NO",});
      Swal.fire('Eliminado', 'La cita fue eliminada correctamente.', 'success');
      fetchData(); // refresca la lista
    } catch (error) {
      Swal.fire('Error', 'No se pudo eliminar la cita.', 'error');
    }
    
  }
    }else {
          Swal.fire({
            icon: 'warning',
            title: 'Acción no permitida',
            text: 'Esta acción solo está permitida para administradores.',
          });}
  
  
};


  return (
    <div className="container mb-3 cie-container">
      {/* Estilos propios: mismo lenguaje visual que ViewSARS/ViewERI/ViewActualizacion */}
      <style>{`
        .cie-container h3 {
          font-weight: 700;
          color: #1f3a5f;
        }

        .cie-card {
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 2px 14px rgba(0,0,0,0.08);
          padding: 1.25rem 1.25rem 0.5rem;
          margin-bottom: 1.75rem;
        }

        .cie-card-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .cie-table-wrapper {
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e7ebf0;
        }

        .cie-table {
          margin-bottom: 0;
        }

        .cie-table thead th {
          background: linear-gradient(135deg, #374151, #6b7280);
          color: #fff;
          border: none;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          padding: 0.85rem 0.9rem;
          vertical-align: middle;
        }

        .cie-table tbody td {
          padding: 0.75rem 0.9rem;
          vertical-align: middle;
          font-size: 0.92rem;
          border-color: #eef1f4;
        }

        .cie-table tbody tr:hover {
          background-color: #f4f5f6;
          transition: background-color 0.15s ease-in-out;
        }

        .cie-empty-row td {
          text-align: center;
          padding: 1.25rem;
          color: #8a94a6;
          font-style: italic;
        }

        .cie-action-btn {
          border-radius: 8px !important;
          margin: 0 2px;
        }

        /* Modales */
        .modal-header.cie-header {
          background: #374151;
          color: #fff;
        }
        .modal-header.cie-header .btn-close {
          filter: invert(1) brightness(2);
        }

        .cie-modal-body .form-group {
          margin-bottom: 1rem;
        }

        .cie-modal-body label {
          font-weight: 600;
          color: #334155;
          font-size: 0.88rem;
          margin-bottom: 4px;
          display: block;
        }

        .cie-modal-body .form-control,
        .cie-modal-body textarea {
          border-radius: 8px;
          border: 1px solid #dbe2ea;
        }
      `}</style>

      <h3>Cierre de Sistema de Alerta Temprana {codigo}</h3>

      <div className="cie-card">
        <div className="cie-card-header">
          <h5 className="mb-0">Cierre</h5>
          <Button
            variant="success"
            onClick={() => setShowModalCita(true)}
            disabled={citas.length > 0}
          >
            Cierre de alerta
          </Button>
        </div>

        {loading ? <p>Cargando citas...</p> : (
          <div className="cie-table-wrapper">
            <table className="table table-striped cie-table">
              <thead>
                <tr>
                  <th>Fecha Cita</th><th>Gestor</th><th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {citas.length ? citas.map(c => (
                  <tr key={c.id}>
                    <td>{c.Fecha}</td>
                    <td>{c.Gestor}</td>
                    <td>
                      <Button variant="info" size="sm" className="cie-action-btn" onClick={() => {
                        setViewItem(c);
                        setShowViewCitas(true);
                      }}>
                        <i className="fas fa-eye"></i>
                      </Button>
                      <Button
                        variant="warning"
                        size="sm"
                        className="cie-action-btn"
                        onClick={() => {
                          if (usernivel === '1') {
                            setViewItem(c);
                            setFechaCita(c.Fecha);
                            setTema(c.Conclusion);
                            setShowEditCitas(true);
                          } else {
                            Swal.fire({
                              icon: 'warning',
                              title: 'Acción no permitida',
                              text: 'Esta acción solo está permitida para administradores.',
                            });
                          }
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        className="cie-action-btn"
                        onClick={() => handleDeleteCita(c.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                )) : (
                  <tr className="cie-empty-row"><td colSpan="3">No se ha activado ningún cierre</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal Detalle Cita */}
      <Modal show={showViewCitas} onHide={() => {
        setShowViewCitas(false);
        setViewItem(null);
      }}backdrop="static"
              keyboard={false}>
        <Modal.Header className="cie-header"><Modal.Title>Detalle de cierre</Modal.Title></Modal.Header>
        <Modal.Body className="cie-modal-body">
          {viewItem && (
            <>
              <p><strong>Código SAT:</strong> {viewItem.Codigo}</p>
              <p><strong>Fecha:</strong> {viewItem.Fecha}</p>
              <p style={{ whiteSpace: 'pre-line' }}>
              <strong>Conclusion:</strong> {viewItem.Conclusion}</p>
              <p><strong>Gestor:</strong> {viewItem.Gestor}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={() => setShowViewCitas(false)}>Cerrar</Button></Modal.Footer>
      </Modal>


      {/* Modal Activar Cita */}
       <Modal show={showModalCita} onHide={() => {
        setShowModalCita(false);
        resetCitaFields();
      }}backdrop="static"
              keyboard={false}>
        <Modal.Header className="cie-header"><Modal.Title>Cerrar Sistema de alerta temprana</Modal.Title></Modal.Header>
        <Modal.Body className="cie-modal-body">
          <div className="form-group">
          <label>Fecha:</label>
       <input
    type="Date"
    className="form-control"
    value={fechaCita}
    readOnly
  />
</div>
           <div className="form-group">
            <label>Conclusiones:</label>
            <textarea className="form-control" value={tema} onChange={e => setTema(e.target.value)}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModalCita(false);
            resetCitaFields();
          }}>Cancelar</Button>
          <Button variant="success" onClick={async () => {
  try {

    Swal.fire({
            title: 'Guardando información...',
            text: 'Por favor espera un momento',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
    // 1) Crear el registro
    await axios.post(URI_CIT, {
      Codigo: codigo,
      Fecha: fechaCita,
      Conclusion: tema,
      Gestor: gestor,
    });

    // 2) Luego cerrar el SAT
    await axios.put(`sat/codigo/${codigo}`, {
      Cierra_SAT: "SI",
    });

    // 3) Finalmente enviar el correo/acción de tipo “CIERRE”
    await axios.get(URI3, {
      params: {
        codigo: codigo,
        tipo: "CIERRE",
        gestor: gestor
      },
    });

    Swal.fire({
          icon: 'success',
          title: 'Guardado exitoso',
          text: 'La información se ha guardado correctamente.',
          timer: 2000,
          showConfirmButton: false,
        });
    setShowModalCita(false);
    resetCitaFields();
    fetchData();
 } catch (error) {
     // ❌ En caso de error
     Swal.fire({
       icon: 'error',
       title: 'Error al guardar',
       text: 'Ocurrió un problema al guardar la información.',
     });
     console.error(error);
   } 
}}>
  Guardar
</Button>

        </Modal.Footer>
      </Modal>

      <Modal
  show={showEditCitas}
  onHide={() => {
    setShowEditCitas(false);
    resetCitaFields();
  }}backdrop="static"
              keyboard={false}
>
  <Modal.Header className="cie-header">
    <Modal.Title>Editar Cierre</Modal.Title>
  </Modal.Header>

  <Modal.Body className="cie-modal-body">
    <div className="form-group">
      <label>Fecha:</label>
      <input
        type="date"
        className="form-control"
        value={fechaCita}
        onChange={e => setFechaCita(e.target.value)}
      />
    </div>
      <div className="form-group">
      <label>Conclusiones:</label>
      <textarea
        className="form-control"
        value={tema}
        onChange={e => setTema(e.target.value)}
      ></textarea>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => {
        setShowEditCitas(false);
        resetCitaFields();
      }}
    >
      Cancelar
    </Button>
    <Button
      variant="success"
      onClick={async () => {
        try {
          await axios.put(`${URI_CIT}${viewItem.id}`, {
            Codigo: codigo,
            Fecha: fechaCita,
            Conclusion: tema,
            Gestor: gestor,
          });
          Swal.fire('Éxito', 'CIERRE actualizada correctamente', 'success');
          setShowEditCitas(false);
          resetCitaFields();
          fetchData();
        } catch (error) {
          Swal.fire('Error', 'No se pudo actualizar la cita', 'error');
        }
      }}
    >
      Guardar Cambios
    </Button>
  </Modal.Footer>
</Modal>


      <Button variant="secondary" onClick={() => navigate(-1)}>Volver</Button>
    </div>
  );
};

export default ViewCierre;